/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Decklist_RequiredInputs */



/**
* | output |
* | --- |
* | "Decklist Required" |
*
* @param {Tfield_Decklist_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_decklist_required = /** @type {((inputs?: Tfield_Decklist_RequiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Decklist_RequiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deck requis")
	if (locale === "es") return /** @type {LocalizedString} */ ("Deck obligatorio")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Lista de Deck Obrigatória")
	if (locale === "it") return /** @type {LocalizedString} */ ("Decklist Obbligatoria")
	return /** @type {LocalizedString} */ ("Decklist Required")
});